(function () {
  var header = document.querySelector('[data-header]');
  var announcement = document.querySelector('[data-announcement]');
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  var WISHLIST_KEY = 'sp_wishlist_v1';
  var RECENT_KEY = 'sp_recently_viewed_v1';
  var COMPARE_KEY = 'sp_compare_v1';
  var TOAST_DURATION_MS = 3000;
  var themeUtils = window.ShopThemeUtils || {};
  var themeDom = window.ShopThemeDom || {};
  var formatMoney = themeUtils.formatMoney || function (cents) {
    var n = Number(cents || 0) / 100;
    return '$' + n.toFixed(2);
  };
  var escapeHtml = themeUtils.escapeHtml || function (value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };
  var normalizePrice = themeUtils.normalizePrice || function (raw) {
    if (raw === null || raw === undefined || raw === '') return 0;

    if (typeof raw === 'string') {
      var cleanRaw = raw.replace(/,/g, '').trim();
      if (!cleanRaw) return 0;

      if (cleanRaw.indexOf('.') !== -1) {
        var dollars = Number(cleanRaw);
        return Number.isFinite(dollars) ? Math.round(dollars * 100) : 0;
      }

      var centsFromString = Number(cleanRaw);
      return Number.isFinite(centsFromString) ? Math.round(centsFromString) : 0;
    }

    var n = Number(raw);
    if (!Number.isFinite(n)) return 0;
    if (Number.isInteger(n)) return n;
    return Math.round(n * 100);
  };
  var buildQuoteCartLines = themeUtils.buildQuoteCartLines || function (cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return ['- No cart items detected'];
    }

    return cart.items.map(function (item) {
      var line = '- ' + String(item.product_title || item.title || 'Item');
      if (item.variant_title && item.variant_title !== 'Default Title') {
        line += ' [' + String(item.variant_title) + ']';
      }
      line += ' (Qty: ' + String(item.quantity || 1) + ')';
      return line;
    });
  };
  var extractQuoteAdditionalDetails = themeUtils.extractQuoteAdditionalDetails || function (value, label) {
    var text = String(value || '');
    var markerLabel = String(label || 'Additional details:');
    var marker = '\n\n' + markerLabel + '\n';
    var markerIndex = text.indexOf(marker);
    if (markerIndex !== -1) {
      return text.slice(markerIndex + marker.length).trim();
    }
    if (text.indexOf(markerLabel + '\n') === 0) {
      return text.slice((markerLabel + '\n').length).trim();
    }
    return text.trim();
  };
  var applyCardVariantSelection = themeDom.applyCardVariantSelection || function (card, button) {
    if (!card || !button) return;
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    card.querySelectorAll('[data-card-variant-option]').forEach(function (optionButton) {
      var isActive = optionButton === button;
      optionButton.classList.toggle('is-active', isActive);
      optionButton.setAttribute('aria-pressed', String(isActive));
    });

    var variantInput = card.querySelector('.sp-card__form input[name="id"]');
    if (variantInput) variantInput.value = variantId;

    var price = button.getAttribute('data-variant-price');
    var compare = button.getAttribute('data-variant-compare');
    var priceEl = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare]');

    if (priceEl) priceEl.textContent = formatMoney(price);
    if (compareEl) {
      if (Number(compare || 0) > Number(price || 0)) {
        compareEl.textContent = formatMoney(compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var mediaEl = card.querySelector('[data-card-media]');
    var imageUrl = button.getAttribute('data-variant-image');
    if (mediaEl && imageUrl) mediaEl.src = imageUrl;

    var isAvailable = button.getAttribute('data-variant-available') === 'true';
    var addButton = card.querySelector('[data-card-add]');
    if (addButton) {
      var defaultLabel = addButton.getAttribute('data-default-label') || 'Add to cart';
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? defaultLabel : 'Sold out';
      addButton.classList.toggle('sp-btn--muted', !isAvailable);
      addButton.classList.toggle('sp-btn--primary', isAvailable);
    }
  };
  var buildQuotePreview = themeDom.buildQuotePreview || function (cart, existingValue, additionalDetailsLabel) {
    var details = extractQuoteAdditionalDetails(existingValue, additionalDetailsLabel);
    var preview = [
      'Cart items:',
      buildQuoteCartLines(cart).join('\n'),
      '',
      String(additionalDetailsLabel || 'Additional details:')
    ];

    if (details) preview.push(details);

    return preview.join('\n');
  };
  var getQuotePreviewValue = themeDom.getQuotePreviewValue || function (form, cart, additionalDetailsLabel) {
    if (!form) return '';
    var messageInput = form.querySelector('[data-quote-message]');
    if (!messageInput) return buildQuotePreview(cart, '', additionalDetailsLabel);
    return buildQuotePreview(cart, messageInput.value, additionalDetailsLabel);
  };
  var buildQuoteMessage = themeDom.buildQuoteMessage || function (form, cart, additionalDetailsLabel) {
    if (!form) return '';

    var companyInput = form.querySelector('[data-quote-company]');
    var nameInput = form.querySelector('[data-quote-name]');
    var emailInput = form.querySelector('[data-quote-email]');
    var lines = [
      'Quote Request',
      '',
      'Company: ' + String(companyInput && companyInput.value ? companyInput.value.trim() : ''),
      'Name: ' + String(nameInput && nameInput.value ? nameInput.value.trim() : ''),
      'Email: ' + String(emailInput && emailInput.value ? emailInput.value.trim() : ''),
      '',
      String(getQuotePreviewValue(form, cart, additionalDetailsLabel) || '')
    ];

    return lines.join('\n');
  };
  var syncQuoteFormFields = themeDom.syncQuoteFormFields || function (quoteModalEl, cart, additionalDetailsLabel) {
    if (!quoteModalEl) return;
    var form = quoteModalEl.querySelector('#sp-quote-form');
    if (!form) return;

    var nameInput = form.querySelector('[data-quote-name]');
    var hiddenNameInput = form.querySelector('[data-quote-name-hidden]');
    var emailInput = form.querySelector('[data-quote-email]');
    var hiddenEmailInput = form.querySelector('[data-quote-email-hidden]');
    var hiddenBodyInput = form.querySelector('[data-quote-body]');
    var messageInput = form.querySelector('[data-quote-message]');

    if (hiddenNameInput) {
      hiddenNameInput.value = nameInput && nameInput.value ? nameInput.value.trim() : '';
    }

    if (hiddenEmailInput) {
      hiddenEmailInput.value = emailInput && emailInput.value ? emailInput.value.trim() : '';
    }

    if (messageInput) {
      messageInput.value = getQuotePreviewValue(form, cart, additionalDetailsLabel);
    }

    if (hiddenBodyInput) {
      hiddenBodyInput.value = buildQuoteMessage(form, cart, additionalDetailsLabel);
    }
  };
  var renderCartDrawer = themeDom.renderCartDrawer || function (cart, elements) {
    var cartDrawerItemsEl = elements && elements.cartDrawerItems;
    var cartDrawerSubtotalEl = elements && elements.cartDrawerSubtotal;
    var root = elements && elements.root;
    if (!cartDrawerItemsEl) return;
    (themeDom.updateCartCount || function (itemCount, localRoot) {
      (localRoot || document).querySelectorAll('.sp-cart-link span').forEach(function (node) {
        node.textContent = '(' + String(itemCount || 0) + ')';
      });
    })(cart.item_count, root);

    if (!cart.items || !cart.items.length) {
      cartDrawerItemsEl.innerHTML = '<div class="sp-cart-drawer__empty"><p>Your cart is empty.</p></div>';
      if (cartDrawerSubtotalEl) cartDrawerSubtotalEl.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
      return;
    }

    cartDrawerItemsEl.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title || '') + '">' : '<div class="sp-cart-drawer__thumb-placeholder"></div>';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? '<p>' + escapeHtml(item.variant_title) + '</p>' : '';
      return ''
        + '<article class="sp-cart-drawer__item">'
        + '  <a href="' + escapeHtml(item.url || '/cart') + '" class="sp-cart-drawer__thumb">' + image + '</a>'
        + '  <div class="sp-cart-drawer__meta">'
        + '    <h3><a href="' + escapeHtml(item.url || '/cart') + '">' + escapeHtml(item.product_title || item.title || 'Item') + '</a></h3>'
        +      variantTitle
        + '    <strong>' + formatMoney(item.final_price) + '</strong>'
        + '    <div class="sp-cart-drawer__qty">'
        + '      <button type="button" data-cart-line-change data-line="' + String(index + 1) + '" data-quantity="' + String(Math.max(0, item.quantity - 1)) + '">-</button>'
        + '      <span>' + String(item.quantity) + '</span>'
        + '      <button type="button" data-cart-line-change data-line="' + String(index + 1) + '" data-quantity="' + String(item.quantity + 1) + '">+</button>'
        + '      <button type="button" class="sp-cart-drawer__remove" data-cart-line-change data-line="' + String(index + 1) + '" data-quantity="0">Remove</button>'
        + '    </div>'
        + '  </div>'
        + '</article>';
    }).join('');

    if (cartDrawerSubtotalEl) cartDrawerSubtotalEl.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
  };
  var currentPath = String(window.location.pathname || '/');
  var isCollectionRoute = /^\/collections(?:\/|$)/.test(currentPath);
  var isProductRoute = /^\/products(?:\/|$)/.test(currentPath);

  function onScroll() {
    if (!header) return;
    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
      if (announcement) announcement.classList.add('is-hidden');
    } else {
      header.classList.remove('is-scrolled');
      if (announcement) announcement.classList.remove('is-hidden');
    }
  }

  function initAnnouncementRotation() {
    document.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
      var slides = rotator.querySelectorAll('.sp-announcement__slide');
      if (!slides || slides.length < 2) return;

      var seconds = parseInt(rotator.getAttribute('data-rotate-seconds') || '6', 10);
      var delay = Math.max(3, seconds) * 1000;
      var activeIndex = 0;

      slides.forEach(function (slide, idx) {
        slide.classList.toggle('is-active', idx === 0);
      });

      window.setInterval(function () {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, delay);
    });
  }

  function stripHtml(html) {
    var temp = document.createElement('div');
    temp.innerHTML = html || '';
    return (temp.textContent || temp.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function ensureToastStack() {
    var stack = document.querySelector('[data-toast-stack]');
    if (stack) return stack;
    stack = document.createElement('div');
    stack.className = 'sp-toast-stack';
    stack.setAttribute('data-toast-stack', 'true');
    document.body.appendChild(stack);
    return stack;
  }

  function showToast(message) {
    if (!message) return;
    var stack = ensureToastStack();
    var toast = document.createElement('div');
    toast.className = 'sp-toast';
    toast.textContent = String(message);
    stack.appendChild(toast);
    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    // Fallback for browsers where rAF + class transition is flaky in overlays.
    window.setTimeout(function () {
      toast.classList.add('is-visible');
    }, 30);
    window.setTimeout(function () {
      toast.classList.remove('is-visible');
      window.setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 180);
    }, TOAST_DURATION_MS);
  }

  function getStoredArray(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setStoredArray(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // ignore storage failures
    }
  }

  function getWishlist() {
    return getStoredArray(WISHLIST_KEY).filter(function (item) {
      return typeof item === 'string' && item && !/^\d+$/.test(item);
    });
  }

  function setWishlist(value) {
    setStoredArray(WISHLIST_KEY, value);
  }

  function getCompareHandles() {
    return getStoredArray(COMPARE_KEY).filter(function (item) {
      return typeof item === 'string' && item && !/^\d+$/.test(item);
    }).slice(0, 4);
  }

  function setCompareHandles(value) {
    setStoredArray(COMPARE_KEY, value.slice(0, 4));
  }

  function setWishlistButtonState(button, isActive) {
    button.setAttribute('aria-pressed', String(isActive));
    button.classList.toggle('is-active', isActive);
    button.textContent = isActive ? '♥' : '♡';
  }

  function refreshWishlistButtons() {
    var wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = String(button.getAttribute('data-product-handle') || '');
      setWishlistButtonState(button, handle && wishlist.indexOf(handle) !== -1);
    });
  }

  function refreshCompareButtons() {
    var handles = getCompareHandles();
    document.querySelectorAll('[data-compare-toggle]').forEach(function (button) {
      var handle = String(button.getAttribute('data-product-handle') || '');
      var isActive = handle && handles.indexOf(handle) !== -1;
      button.setAttribute('aria-pressed', String(isActive));
      button.classList.toggle('is-active', isActive);
    });
  }

  function toggleWishlist(button) {
    var handle = String(button.getAttribute('data-product-handle') || '');
    if (!handle) return;

    var wishlist = getWishlist();
    var index = wishlist.indexOf(handle);

    if (index === -1) {
      wishlist.unshift(handle);
      wishlist = wishlist.slice(0, 40);
      showToast('Added to wishlist');
    } else {
      wishlist.splice(index, 1);
      showToast('Removed from wishlist');
    }

    setWishlist(wishlist);
    refreshWishlistButtons();
    renderWishlistSections();
  }

  function addHandlesToWishlist(handles) {
    if (!handles || !handles.length) return;
    var wishlist = getWishlist();

    handles.forEach(function (handle) {
      if (!handle) return;
      var idx = wishlist.indexOf(handle);
      if (idx !== -1) wishlist.splice(idx, 1);
      wishlist.unshift(handle);
    });

    wishlist = wishlist.slice(0, 40);
    setWishlist(wishlist);
    refreshWishlistButtons();
    renderWishlistSections();
    showToast('Added selected items to wishlist');
  }

  function removeHandlesFromWishlist(handles) {
    if (!handles || !handles.length) return;
    var handleMap = {};
    handles.forEach(function (handle) {
      if (!handle) return;
      handleMap[String(handle)] = true;
    });

    var wishlist = getWishlist().filter(function (handle) {
      return !handleMap[String(handle)];
    });

    setWishlist(wishlist);
    refreshWishlistButtons();
    renderWishlistSections();
    showToast('Removed selected wishlist items');
  }

  function recordRecentlyViewed() {
    var productContext = document.querySelector('[data-product-context]');
    if (!productContext) return;

    var handle = productContext.getAttribute('data-product-handle');
    if (!handle) return;

    var items = getStoredArray(RECENT_KEY);
    items = items.filter(function (item) { return item !== handle; });
    items.unshift(handle);
    setStoredArray(RECENT_KEY, items.slice(0, 20));
  }

  function createCardHtml(product) {
    var comparePrice = Number(product.compare_at_price || 0);
    var price = Number(product.price || 0);
    var onSale = comparePrice > price;
    var soldOut = product.available === false;
    var variant = (product.variants || []).find(function (v) { return v.available; }) || (product.variants || [])[0];
    var image = product.featured_image || ((product.images && product.images[0]) ? product.images[0] : '');
    var productUrl = '/products/' + product.handle;

    var badges = '';
    if (onSale) badges += '<span class="sp-badge sp-badge--sale">Sale</span>';
    if (soldOut) badges += '<span class="sp-badge sp-badge--soldout">Sold out</span>';

    var formHtml = '';
    if (variant) {
      formHtml += '<form method="post" action="/cart/add" class="sp-card__form">';
      formHtml += '<input type="hidden" name="id" value="' + escapeHtml(variant.id) + '">';
      formHtml += '<button type="button" class="sp-btn sp-btn--muted sp-card__button" data-quick-view data-product-handle="' + escapeHtml(product.handle) + '">Quick view</button>';
      if (soldOut) {
        formHtml += '<button type="button" class="sp-btn sp-btn--muted sp-card__button" disabled>Sold out</button>';
      } else {
        formHtml += '<button type="submit" class="sp-btn sp-btn--primary sp-card__button" data-card-add>Add to cart</button>';
      }
      formHtml += '</form>';
    }

    return ''
      + '<article class="sp-card" data-product-card data-product-id="' + escapeHtml(product.id) + '" data-product-handle="' + escapeHtml(product.handle) + '">'
      + '  <a href="' + productUrl + '" class="sp-card__media-wrap">'
      + (image
        ? '    <img class="sp-card__media" loading="lazy" src="' + image + '" alt="' + escapeHtml(product.title) + '" data-card-media>'
        : '    <div class="sp-card__media sp-card__media--placeholder"></div>')
      + '    <div class="sp-card__badges">' + badges + '</div>'
      + '  </a>'
      + '  <div class="sp-card__actions">'
      + '    <label class="sp-card__select" aria-label="Select ' + escapeHtml(product.title) + '">'
      + '      <input type="checkbox" data-card-select data-product-handle="' + escapeHtml(product.handle) + '">'
      + '    </label>'
      + '  </div>'
      + '  <div class="sp-card__body">'
      + '    <p class="sp-card__vendor">' + escapeHtml(product.vendor) + '</p>'
      + '    <h3 class="sp-card__title"><a href="' + productUrl + '">' + escapeHtml(product.title) + '</a></h3>'
      + '    <div class="sp-card__price-row">'
      + '      <span class="sp-card__price" data-card-price>' + formatMoney(price) + '</span>'
      + (onSale ? '      <span class="sp-card__compare" data-card-compare>' + formatMoney(comparePrice) + '</span>' : '      <span class="sp-card__compare" data-card-compare hidden></span>')
      + '    </div>'
      + formHtml
      + '  </div>'
      + '</article>';
  }

  function updateSelectedCardVisualState(input) {
    if (!input) return;
    var card = input.closest('[data-product-card]');
    if (!card) return;
    card.classList.toggle('is-selected', Boolean(input.checked));
  }

  function syncSelectedCardVisualState(scope) {
    (scope || document).querySelectorAll('[data-card-select]').forEach(function (input) {
      updateSelectedCardVisualState(input);
    });
  }

  function initProductCardVariantSelectors(scope) {
    (scope || document).querySelectorAll('[data-product-card]').forEach(function (card) {
      if (card.getAttribute('data-card-variant-init') === 'true') return;
      card.setAttribute('data-card-variant-init', 'true');

      var addButton = card.querySelector('[data-card-add]');
      if (addButton && !addButton.getAttribute('data-default-label')) {
        addButton.setAttribute('data-default-label', addButton.textContent || 'Add to cart');
      }

      card.querySelectorAll('[data-card-variant-option]').forEach(function (button) {
        button.addEventListener('click', function () {
          applyCardVariantSelection(card, button);
        });
      });
    });
  }

  function initCollectionLoadMore() {
    var AUTOLOAD_VIEWPORT_BUFFER_PX = 1200;
    var AUTOLOAD_OBSERVER_ROOT_MARGIN = '900px 0px';

    document.querySelectorAll('[data-collection-load-more]').forEach(function (loadMore) {
      if (loadMore.getAttribute('data-load-more-init') === 'true') return;
      loadMore.setAttribute('data-load-more-init', 'true');

      var sentinel = loadMore.querySelector('[data-load-more-sentinel]');
      var sectionRoot = loadMore.closest('.sp-collection-main') || document;
      var grid = sectionRoot.querySelector('[data-collection-products]');
      var infiniteScrollSetting = (loadMore.getAttribute('data-enable-infinite-scroll') || 'true').toLowerCase();
      var shouldAutoLoad = infiniteScrollSetting === 'true';
      var shouldObserve = shouldAutoLoad && 'IntersectionObserver' in window;
      var observer = null;
      var rafScheduled = false;
      var nextPageCache = null;
      var prefetchInFlightUrl = '';

      function buildCollectionSectionUrl(url) {
        if (!url) return '';
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        return url + separator + 'section_id=main-collection';
      }

      function fetchCollectionPageHtml(url) {
        var sectionUrl = buildCollectionSectionUrl(url);
        return fetch(sectionUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Section fetch failed');
            return response.text();
          })
          .then(function (html) {
            if (html.indexOf('data-collection-products') === -1) throw new Error('Invalid section markup');
            return html;
          })
          .catch(function () {
            return fetch(url, { credentials: 'same-origin' })
              .then(function (response) {
                if (!response.ok) throw new Error('Unable to load collection page');
                return response.text();
              });
          });
      }

      function isNearBottom() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        var viewport = window.innerHeight || document.documentElement.clientHeight || 0;
        var height = document.documentElement.scrollHeight || 0;
        return (scrollTop + viewport) >= (height - AUTOLOAD_VIEWPORT_BUFFER_PX);
      }

      function tryAutoLoad() {
        rafScheduled = false;
        if (!shouldAutoLoad) return;
        if (!loadMore.getAttribute('data-next-url')) return;

        var sentinelNearViewport = false;
        if (sentinel && sentinel.getBoundingClientRect) {
          var rect = sentinel.getBoundingClientRect();
          sentinelNearViewport = rect.top <= (window.innerHeight + AUTOLOAD_VIEWPORT_BUFFER_PX);
        }

        if (isNearBottom() || sentinelNearViewport) appendNextPage();
      }

      function onScrollOrResize() {
        if (!shouldAutoLoad || rafScheduled) return;
        rafScheduled = true;
        window.requestAnimationFrame(tryAutoLoad);
      }

      function syncVisibility(nextUrl) {
        var hasNext = Boolean(nextUrl);
        if (!hasNext) {
          if (observer && sentinel) observer.unobserve(sentinel);
        }
      }

      function appendNextPage() {
        var nextUrl = loadMore.getAttribute('data-next-url') || '';
        if (!nextUrl || !grid || loadMore.getAttribute('data-loading') === 'true') return;

        loadMore.setAttribute('data-loading', 'true');

        var htmlPromise = (nextPageCache && nextPageCache.url === nextUrl)
          ? Promise.resolve(nextPageCache.html)
          : fetchCollectionPageHtml(nextUrl);

        htmlPromise
          .then(function (html) {
            nextPageCache = null;
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-collection-products]');
            if (nextGrid) {
              Array.prototype.slice.call(nextGrid.children).forEach(function (node) {
                grid.appendChild(node);
              });
            }

            var nextLoadMore = doc.querySelector('[data-collection-load-more]');
            var upcomingUrl = nextLoadMore ? nextLoadMore.getAttribute('data-next-url') : '';
            if (upcomingUrl) {
              loadMore.setAttribute('data-next-url', upcomingUrl);
            } else {
              loadMore.removeAttribute('data-next-url');
            }
            syncVisibility(upcomingUrl);
            prefetchNextPage();
            initProductCardVariantSelectors(grid);
            refreshWishlistButtons();
            refreshCompareButtons();
            initCollectionBulkActions();
            syncSelectedCardVisualState(grid);
          })
          .catch(function () {})
          .finally(function () {
            loadMore.setAttribute('data-loading', 'false');
            if (shouldAutoLoad && isNearBottom()) appendNextPage();
          });
      }

      function prefetchNextPage() {
        var nextUrl = loadMore.getAttribute('data-next-url') || '';
        if (!nextUrl) return;
        if (loadMore.getAttribute('data-loading') === 'true') return;
        if (nextPageCache && nextPageCache.url === nextUrl) return;
        if (prefetchInFlightUrl === nextUrl) return;

        prefetchInFlightUrl = nextUrl;
        fetchCollectionPageHtml(nextUrl)
          .then(function (html) {
            if (loadMore.getAttribute('data-next-url') === nextUrl) {
              nextPageCache = { url: nextUrl, html: html };
            }
          })
          .catch(function () {})
          .finally(function () {
            if (prefetchInFlightUrl === nextUrl) prefetchInFlightUrl = '';
          });
      }

      var initialNextUrl = loadMore.getAttribute('data-next-url') || '';
      syncVisibility(initialNextUrl);

      if (shouldAutoLoad) {
        window.addEventListener('scroll', onScrollOrResize, { passive: true });
        window.addEventListener('resize', onScrollOrResize, { passive: true });
      }

      if (shouldObserve && sentinel) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) appendNextPage();
            if (entry.isIntersecting) prefetchNextPage();
          });
        }, { rootMargin: AUTOLOAD_OBSERVER_ROOT_MARGIN });
        observer.observe(sentinel);
      }
    });
  }

  function initSearchLoadMore() {
    document.querySelectorAll('[data-search-load-more]').forEach(function (loadMore) {
      if (loadMore.getAttribute('data-search-load-more-init') === 'true') return;
      loadMore.setAttribute('data-search-load-more-init', 'true');

      var sentinel = loadMore.querySelector('[data-search-load-more-sentinel]');
      var sectionRoot = loadMore.closest('.sp-collection-main') || document;
      var grid = sectionRoot.querySelector('[data-search-products]');
      if (!grid) return;

      var loading = false;

      function appendNextPage() {
        if (loading) return;
        var nextUrl = loadMore.getAttribute('data-next-url') || '';
        if (!nextUrl) return;
        loading = true;

        fetch(nextUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to load search page');
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-search-products]');
            if (nextGrid) {
              Array.prototype.slice.call(nextGrid.children).forEach(function (node) {
                grid.appendChild(node);
              });
            }

            var nextLoadMore = doc.querySelector('[data-search-load-more]');
            var upcomingUrl = nextLoadMore ? (nextLoadMore.getAttribute('data-next-url') || '') : '';
            if (upcomingUrl) loadMore.setAttribute('data-next-url', upcomingUrl);
            else loadMore.removeAttribute('data-next-url');

            initProductCardVariantSelectors(grid);
            refreshWishlistButtons();
            refreshCompareButtons();
            syncSelectedCardVisualState(grid);
          })
          .catch(function () {})
          .finally(function () {
            loading = false;
          });
      }

      if (sentinel && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) appendNextPage();
          });
        }, { rootMargin: '1800px 0px' });
        observer.observe(sentinel);
      } else {
        window.addEventListener('scroll', function () {
          var nextUrl = loadMore.getAttribute('data-next-url') || '';
          if (!nextUrl || loading) return;
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
          var viewport = window.innerHeight || document.documentElement.clientHeight || 0;
          var height = document.documentElement.scrollHeight || 0;
          if ((scrollTop + viewport) >= (height - 1800)) appendNextPage();
        }, { passive: true });
      }
    });
  }

  function initCollectionFilterAvailability() {
    function filterKey(param, value) {
      return String(param || '') + '||' + String(value || '');
    }

    document.querySelectorAll('[data-collection-filters-form]').forEach(function (form) {
      if (form.getAttribute('data-filter-state-init') === 'true') return;
      form.setAttribute('data-filter-state-init', 'true');

      var requestToken = 0;
      var checkboxInputs = form.querySelectorAll('[data-filter-checkbox]');
      if (!checkboxInputs.length) return;

      function applyRemoteState(remoteForm) {
        if (!remoteForm) return;
        var remoteState = {};

        remoteForm.querySelectorAll('[data-filter-checkbox]').forEach(function (remoteInput) {
          var key = filterKey(remoteInput.getAttribute('data-filter-param'), remoteInput.getAttribute('data-filter-value'));
          if (!key) return;
          var remoteLabel = remoteInput.parentElement ? remoteInput.parentElement.querySelector('span') : null;
          remoteState[key] = {
            disabled: Boolean(remoteInput.disabled),
            label: remoteLabel ? (remoteLabel.textContent || '') : ''
          };
        });

        checkboxInputs.forEach(function (input) {
          var key = filterKey(input.getAttribute('data-filter-param'), input.getAttribute('data-filter-value'));
          var state = remoteState[key];
          if (!state) return;

          if (!input.checked) input.disabled = state.disabled;
          else input.disabled = false;

          var label = input.parentElement ? input.parentElement.querySelector('span') : null;
          if (label && state.label) label.textContent = state.label;
        });
      }

      function syncFilterState() {
        requestToken += 1;
        var token = requestToken;
        var params = new URLSearchParams(new FormData(form));
        params.delete('page');
        params.set('section_id', 'main-collection');
        var separator = form.action.indexOf('?') === -1 ? '?' : '&';
        var requestUrl = form.action + separator + params.toString();

        fetch(requestUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Filter sync failed');
            return response.text();
          })
          .then(function (html) {
            if (token !== requestToken) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            applyRemoteState(doc.querySelector('[data-collection-filters-form]'));
          })
          .catch(function () {});
      }

      checkboxInputs.forEach(function (input) {
        input.addEventListener('change', syncFilterState);
      });

      form.querySelectorAll('.sp-filter-price input[type="number"]').forEach(function (input) {
        input.addEventListener('change', syncFilterState);
      });
    });
  }

  function initSearchFilterAvailability() {
    function filterKey(param, value) {
      return String(param || '') + '||' + String(value || '');
    }

    document.querySelectorAll('[data-search-filters-form]').forEach(function (form) {
      if (form.getAttribute('data-filter-state-init') === 'true') return;
      form.setAttribute('data-filter-state-init', 'true');

      var requestToken = 0;
      var checkboxInputs = form.querySelectorAll('[data-filter-checkbox]');
      if (!checkboxInputs.length) return;

      function applyRemoteState(remoteForm) {
        if (!remoteForm) return;
        var remoteState = {};

        remoteForm.querySelectorAll('[data-filter-checkbox]').forEach(function (remoteInput) {
          var key = filterKey(remoteInput.getAttribute('data-filter-param'), remoteInput.getAttribute('data-filter-value'));
          if (!key) return;
          var remoteLabel = remoteInput.parentElement ? remoteInput.parentElement.querySelector('span') : null;
          remoteState[key] = {
            disabled: Boolean(remoteInput.disabled),
            label: remoteLabel ? (remoteLabel.textContent || '') : ''
          };
        });

        checkboxInputs.forEach(function (input) {
          var key = filterKey(input.getAttribute('data-filter-param'), input.getAttribute('data-filter-value'));
          var state = remoteState[key];
          if (!state) return;

          if (!input.checked) input.disabled = state.disabled;
          else input.disabled = false;

          var label = input.parentElement ? input.parentElement.querySelector('span') : null;
          if (label && state.label) label.textContent = state.label;
        });
      }

      function syncFilterState() {
        requestToken += 1;
        var token = requestToken;
        var params = new URLSearchParams(new FormData(form));
        params.delete('page');
        params.set('section_id', 'main-search');
        var separator = form.action.indexOf('?') === -1 ? '?' : '&';
        var requestUrl = form.action + separator + params.toString();

        fetch(requestUrl, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Filter sync failed');
            return response.text();
          })
          .then(function (html) {
            if (token !== requestToken) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            applyRemoteState(doc.querySelector('[data-search-filters-form]'));
          })
          .catch(function () {});
      }

      checkboxInputs.forEach(function (input) {
        input.addEventListener('change', syncFilterState);
      });

      form.querySelectorAll('.sp-filter-price input[type="number"]').forEach(function (input) {
        input.addEventListener('change', syncFilterState);
      });
    });
  }

  function initMegaMenu() {
    var megaMenus = document.querySelectorAll('[data-mega-menu]');
    if (!megaMenus.length) return;

    megaMenus.forEach(function (menu) {
      var summary = menu.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function () {
        if (menu.open) return;
        megaMenus.forEach(function (item) {
          if (item !== menu) item.removeAttribute('open');
        });
      });

    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-mega-close]')) {
        megaMenus.forEach(function (menu) { menu.removeAttribute('open'); });
        return;
      }
      megaMenus.forEach(function (menu) {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
    });
  }

  function loadMegaMenuThumb(link) {
    if (!link || link.classList.contains('is-thumb-ready') || link.getAttribute('data-thumb-loading') === 'true') return;
    var slot = link.querySelector('[data-thumb-slot]');
    var thumbUrl = link.getAttribute('data-thumb-url') || '';
    if (!slot || !thumbUrl) {
      link.classList.add('is-thumb-ready');
      return;
    }

    link.setAttribute('data-thumb-loading', 'true');

    var img = new Image();
    img.decoding = 'sync';
    img.loading = 'eager';
    img.alt = '';
    img.src = thumbUrl;
    img.onload = function () {
      slot.innerHTML = '';
      slot.appendChild(img);
      link.classList.add('is-thumb-ready');
      link.removeAttribute('data-thumb-loading');
    };
    img.onerror = function () {
      link.classList.add('is-thumb-ready');
      link.removeAttribute('data-thumb-loading');
    };
  }

  function hydrateMegaMenuThumbnailsForScope(scope) {
    var root = scope || document;
    var links = Array.prototype.slice.call(root.querySelectorAll('.sp-mega__simple-link[data-thumb-url]:not(.is-thumb-ready)'));
    if (!links.length) return;

    var firstBatch = links.slice(0, 12);
    var secondBatch = links.slice(12, 24);

    firstBatch.forEach(loadMegaMenuThumb);
    if (secondBatch.length) {
      window.setTimeout(function () {
        secondBatch.forEach(loadMegaMenuThumb);
      }, 80);
    }
  }

  function initMegaMenuThumbHydration() {
    var groups = document.querySelectorAll('.sp-mega--text');
    if (!groups.length) return;

    groups.forEach(function (group) {
      if (group.getAttribute('data-thumb-init') === 'true') return;
      group.setAttribute('data-thumb-init', 'true');

      var hydrate = function () {
        hydrateMegaMenuThumbnailsForScope(group);
      };

      group.addEventListener('mouseenter', hydrate, { passive: true });
      group.addEventListener('focusin', hydrate);
      group.addEventListener('touchstart', hydrate, { passive: true });
    });

    // Warm one group only after initial render settles so it does not compete with LCP assets.
    var warmFirstGroup = function () {
      if (groups[0]) hydrateMegaMenuThumbnailsForScope(groups[0]);
    };
    if (isCollectionRoute || isProductRoute) return;
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = connection && connection.saveData;
    var slowNetwork = connection && /2g|3g/.test(String(connection.effectiveType || ''));
    if (saveData || slowNetwork) return;
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmFirstGroup, { timeout: 2200 });
    } else {
      window.setTimeout(warmFirstGroup, 1200);
    }
  }

  function positionMegaPanelWithinViewport(group) {
    if (!group || window.innerWidth <= 991) return;
    var panel = group.querySelector('.sp-mega__panel');
    if (!panel) return;

    panel.style.left = '50%';
    panel.style.transform = 'translateX(-50%)';

    window.requestAnimationFrame(function () {
      var rect = panel.getBoundingClientRect();
      if (!rect || !rect.width) return;
      var viewportPad = 10;
      var shift = 0;

      if (rect.left < viewportPad) {
        shift = viewportPad - rect.left;
      } else if (rect.right > (window.innerWidth - viewportPad)) {
        shift = -(rect.right - (window.innerWidth - viewportPad));
      }

      if (shift) {
        panel.style.transform = 'translateX(calc(-50% + ' + String(shift) + 'px))';
      }
    });
  }

  function initMegaPanelViewportFit() {
    var groups = document.querySelectorAll('.sp-mega--text');
    if (!groups.length) return;

    groups.forEach(function (group) {
      if (group.getAttribute('data-mega-fit-init') === 'true') return;
      group.setAttribute('data-mega-fit-init', 'true');

      var sync = function () { positionMegaPanelWithinViewport(group); };
      group.addEventListener('mouseenter', sync, { passive: true });
      group.addEventListener('focusin', sync);
    });

    window.addEventListener('resize', function () {
      groups.forEach(function (group) { positionMegaPanelWithinViewport(group); });
    });
  }

  function initCollectionLinkPrefetch() {
    if (isCollectionRoute || isProductRoute) return;
    var seen = {};
    var prefetchedCount = 0;
    var MAX_PREFETCH = 12;
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var saveData = connection && connection.saveData;
    var slowNetwork = connection && /2g|3g/.test(String(connection.effectiveType || ''));
    if (saveData || slowNetwork || window.innerWidth <= 991) return;

    function prefetchUrl(url) {
      if (!url || seen[url] || prefetchedCount >= MAX_PREFETCH) return;
      seen[url] = true;
      prefetchedCount += 1;

      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }

    var selectors = '.sp-mega__simple-link, .sp-mobile-nav__child, .sp-mega__trigger, .sp-header__nav > a';
    document.querySelectorAll(selectors).forEach(function (anchor) {
      var href = anchor.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;

      var trigger = function () {
        prefetchUrl(href);
      };

      anchor.addEventListener('mouseenter', trigger, { passive: true });
      anchor.addEventListener('focus', trigger);
    });
  }

  function initPageTransitions() {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    document.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      if (event.defaultPrevented) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var href = link.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (link.closest('[data-compare-overlay], [data-cart-drawer], [data-quickview-modal], [data-promo-popup], [data-exit-intent-popup], [data-quote-modal]')) return;

      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }
      if (url.origin !== window.location.origin) return;
      if (url.href === window.location.href) return;
      if (url.pathname.indexOf('/collections/') === 0) return;

      event.preventDefault();

      if (document.startViewTransition) {
        try {
          document.startViewTransition(function () {
            window.location.href = url.href;
            return Promise.resolve();
          });
          return;
        } catch (e) {}
      }

      document.body.classList.add('sp-page-leaving');
      window.setTimeout(function () {
        window.location.href = url.href;
      }, 140);
    });
  }

  function initSearchAutocomplete() {
    var form = document.querySelector('[data-search-form]');
    var input = form ? form.querySelector('[data-search-input]') : null;
    var panel = form ? form.querySelector('[data-search-autocomplete]') : null;
    if (!form || !input || !panel) return;

    var debounceTimer = null;
    var requestId = 0;
    var lastQuery = '';
    var activeSuggestion = '';

    function closePanel() {
      panel.hidden = true;
      panel.innerHTML = '';
    }

    function openPanel() {
      panel.hidden = false;
    }

    function queryUrl(query) {
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '6');
      params.set('resources[options][unavailable_products]', 'hide');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      return '/search/suggest.json?' + params.toString();
    }

    function fetchFallbackResults(query) {
      var url = '/search?type=product&q=' + encodeURIComponent(query);
      return fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Search fallback failed');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('.sp-card')).slice(0, 6).map(function (card) {
            var link = card.querySelector('.sp-card__title a');
            var image = card.querySelector('.sp-card__media');
            var price = card.querySelector('[data-card-price]');
            var title = link ? (link.textContent || '').trim() : '';
            var href = link ? (link.getAttribute('href') || '') : '';
            return {
              title: title,
              handle: href.replace(/^\/products\//, ''),
              url: href,
              image: image ? image.getAttribute('src') : '',
              price: price ? (price.textContent || '').replace(/[^0-9.]/g, '') : ''
            };
          }).filter(function (item) {
            return item && item.title && item.url;
          });
        });
    }

    function renderResults(query, products) {
      if (!products || !products.length) {
        activeSuggestion = '';
        panel.innerHTML = '<div class="sp-search__autocomplete-view-all"><a href="/search?type=product&q=' + encodeURIComponent(query) + '">View all results</a></div>';
        openPanel();
        return;
      }

      var itemsHtml = products.map(function (product) {
        var title = escapeHtml(product.title || '');
        var url = product.url || ('/products/' + encodeURIComponent(product.handle || ''));
        var image = '';
        if (product.featured_image && product.featured_image.url) image = product.featured_image.url;
        if (!image && product.image && product.image.url) image = product.image.url;
        if (!image && typeof product.featured_image === 'string') image = product.featured_image;
        if (!image && typeof product.image === 'string') image = product.image;
        var price = normalizePrice(product.price || product.price_min || product.price_max);
        var thumb = image
          ? '<img src="' + escapeHtml(image) + '" alt="' + title + '" loading="lazy">'
          : '<span class="sp-search__autocomplete-thumb-fallback">' + escapeHtml((product.title || '?').slice(0, 1)) + '</span>';

        return ''
          + '<li>'
          + '  <a class="sp-search__autocomplete-item" href="' + escapeHtml(url) + '">'
          +      thumb
          + '    <span class="sp-search__autocomplete-title">' + title + '</span>'
          + '    <span class="sp-search__autocomplete-price">' + formatMoney(price) + '</span>'
          + '  </a>'
          + '</li>';
      }).join('');

      panel.innerHTML = ''
        + '<ul class="sp-search__autocomplete-list">' + itemsHtml + '</ul>'
        + '<a class="sp-search__autocomplete-view-all" href="/search?type=product&q=' + encodeURIComponent(query) + '">View all results</a>';
      openPanel();

      var firstTitle = String((products[0] && products[0].title) || '').trim();
      var queryLower = String(query || '').toLowerCase();
      var firstLower = firstTitle.toLowerCase();
      if (document.activeElement === input && queryLower.length >= 2 && firstLower.indexOf(queryLower) === 0 && firstTitle.length > query.length) {
        activeSuggestion = firstTitle;
      } else {
        activeSuggestion = '';
      }
    }

    function fetchResults(query) {
      var trimmed = String(query || '').trim();
      if (trimmed.length < 2) {
        lastQuery = '';
        closePanel();
        return;
      }
      if (trimmed === lastQuery) return;
      lastQuery = trimmed;
      requestId += 1;
      var currentRequestId = requestId;

      fetch(queryUrl(trimmed), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Suggest failed');
          return response.json();
        })
        .then(function (data) {
          if (currentRequestId !== requestId) return;
          var products = (((data || {}).resources || {}).results || {}).products || [];
          if (products && products.length) {
            renderResults(trimmed, products);
            return;
          }
          return fetchFallbackResults(trimmed).then(function (fallbackProducts) {
            if (currentRequestId !== requestId) return;
            renderResults(trimmed, fallbackProducts || []);
          });
        })
        .catch(function () {
          if (currentRequestId !== requestId) return;
          fetchFallbackResults(trimmed)
            .then(function (fallbackProducts) {
              if (currentRequestId !== requestId) return;
              renderResults(trimmed, fallbackProducts || []);
            })
            .catch(function () {
              if (currentRequestId !== requestId) return;
              closePanel();
            });
        });
    }

    input.addEventListener('input', function () {
      if (debounceTimer) window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        fetchResults(input.value || '');
      }, 300);
    });

    input.addEventListener('focus', function () {
      if ((input.value || '').trim().length >= 2) fetchResults(input.value);
    });

    input.addEventListener('keydown', function (event) {
      var key = event.key;
      if (!activeSuggestion) return;
      if (key === 'Tab' || key === 'ArrowRight' || key === 'End') {
        var query = String(input.value || '');
        var start = input.selectionStart || 0;
        var end = input.selectionEnd || 0;
        if (start !== end || (activeSuggestion.toLowerCase().indexOf(query.toLowerCase()) === 0)) {
          event.preventDefault();
          input.value = activeSuggestion;
          try {
            input.setSelectionRange(activeSuggestion.length, activeSuggestion.length);
          } catch (e) {}
          activeSuggestion = '';
        }
      }
    });

    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) closePanel();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });
  }

  function initBackToTop() {
    var button = document.querySelector('[data-back-to-top]');
    if (!button) return;
    var threshold = window.innerWidth <= 991 ? 180 : 500;
    var ticking = false;

    function syncState() {
      button.hidden = window.scrollY <= threshold;
    }

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncState();
      });
    }, { passive: true });
    syncState();
  }

  function initExitIntentPopup() {
    var popup = document.querySelector('[data-exit-intent-popup]');
    if (!popup) return;

    var signupPanel = popup.querySelector('[data-exit-intent-panel]');
    var offerPanel = popup.querySelector('[data-exit-intent-offer]');
    var form = popup.querySelector('#sp-exit-intent-form');
    var submitButton = form ? form.querySelector('button[type="submit"]') : null;
    var sessionKey = 'sp_exit_intent_seen_v1';
    var offerPendingKey = 'sp_exit_intent_offer_pending_v1';
    var offerClaimedKey = 'sp_exit_intent_claimed_v1';
    var dismissed = false;
    var minTimeOnPageMs = 7000;
    var loadedAt = Date.now();
    var hasPendingOffer = false;
    var hasClaimedOffer = false;
    var offerParam = '';
    var customerPostedParam = '';
    var formTypeParam = '';
    var pathname = window.location.pathname || '/';
    var isHomepage = pathname === '/';
    var isMobileViewport = window.matchMedia ? window.matchMedia('(max-width: 991px)').matches : window.innerWidth < 992;
    var mobileIntentArmed = false;
    var mobileIntentArmedAt = 0;
    var exitIntentSubmitting = false;

    try {
      hasPendingOffer = sessionStorage.getItem(offerPendingKey) === '1';
      hasClaimedOffer = sessionStorage.getItem(offerClaimedKey) === '1';
    } catch (e) {}

    // Cleanup from older logic that used persistent localStorage flags.
    try {
      localStorage.removeItem('sp_exit_intent_offer_pending_local_v1');
      localStorage.removeItem('sp_exit_intent_claimed_local_v1');
    } catch (e) {}
    try {
      var pageUrl = new URL(window.location.href);
      offerParam = pageUrl.searchParams.get('exit_offer') || '';
      customerPostedParam = pageUrl.searchParams.get('customer_posted') || '';
      formTypeParam = pageUrl.searchParams.get('form_type') || '';
    } catch (e) {}
    var fromNewsletterSubmit = customerPostedParam === 'true' && formTypeParam === 'customer';
    var shouldShowOfferNow = isHomepage && (hasPendingOffer || offerParam === '1' || fromNewsletterSubmit);

    function showOfferState() {
      if (signupPanel) signupPanel.hidden = true;
      if (offerPanel) offerPanel.hidden = false;
    }

    function close() {
      popup.hidden = true;
      dismissed = true;
      try { sessionStorage.setItem(sessionKey, '1'); } catch (e) {}
    }

    function openSignup() {
      if (signupPanel) signupPanel.hidden = false;
      if (offerPanel) offerPanel.hidden = true;
      popup.hidden = false;
    }

    function open() {
      if (dismissed) return;
      if (hasClaimedOffer) return;
      openSignup();
      try { sessionStorage.setItem(sessionKey, '1'); } catch (e) {}
    }

    function canTriggerExitIntent() {
      if (dismissed) return false;
      if (hasClaimedOffer) return false;
      if ((Date.now() - loadedAt) < minTimeOnPageMs) return false;
      return true;
    }

    popup.querySelectorAll('[data-exit-intent-close]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-submitting') === 'true') {
          event.preventDefault();
          return;
        }
        exitIntentSubmitting = true;
        form.setAttribute('data-submitting', 'true');
        try {
          sessionStorage.setItem(offerPendingKey, '1');
          sessionStorage.setItem(offerClaimedKey, '1');
          sessionStorage.setItem(sessionKey, '1');
        } catch (e) {}
        hasClaimedOffer = true;
        popup.hidden = true;
        dismissed = true;
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Redirecting...';
        }
      });
    }

    try {
      if (hasClaimedOffer && !shouldShowOfferNow) return;
      if (!shouldShowOfferNow && sessionStorage.getItem(sessionKey) === '1') return;
    } catch (e) {}

    if (!isMobileViewport) {
      document.addEventListener('mouseleave', function (event) {
        if (!canTriggerExitIntent()) return;
        if (!event) return;
        // Closest browser-supported approximation of "about to close tab/window":
        // cursor leaves through the top browser chrome area.
        if (Number(event.clientY) > 0) return;
        open();
      });
    } else if (!shouldShowOfferNow) {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          if (!canTriggerExitIntent()) return;
          mobileIntentArmed = true;
          mobileIntentArmedAt = Date.now();
          return;
        }

        if (document.visibilityState === 'visible' && mobileIntentArmed) {
          var wasRecentlyHidden = (Date.now() - mobileIntentArmedAt) < 20000;
          mobileIntentArmed = false;
          mobileIntentArmedAt = 0;
          if (wasRecentlyHidden && canTriggerExitIntent()) {
            open();
          }
        }
      });

      window.addEventListener('beforeunload', function (event) {
        if (exitIntentSubmitting) return;
        if (!canTriggerExitIntent()) return;
        // Fallback when a browser allows unload confirmation on mobile.
        event.preventDefault();
        event.returnValue = '';
      });
    }

    if (shouldShowOfferNow) {
      showOfferState();
      popup.hidden = false;
      dismissed = true;
      try {
        sessionStorage.setItem(sessionKey, '1');
        sessionStorage.removeItem(offerPendingKey);
      } catch (e) {}
      if (window.history && window.history.replaceState) {
        try {
          var cleanUrl = new URL(window.location.href);
          cleanUrl.searchParams.delete('exit_offer');
          cleanUrl.searchParams.delete('customer_posted');
          cleanUrl.searchParams.delete('form_type');
          cleanUrl.searchParams.delete('utf8');
          window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        } catch (e) {}
      }
    }
  }

  function renderRecentlyViewed() {
    var sections = document.querySelectorAll('[data-recently-viewed]');
    if (!sections.length) return;

    var handles = getStoredArray(RECENT_KEY);
    var productContext = document.querySelector('[data-product-context]');
    var currentHandle = productContext ? productContext.getAttribute('data-product-handle') : '';
    if (currentHandle) {
      handles = handles.filter(function (h) { return h !== currentHandle; });
    }

    sections.forEach(function (section) {
      var limit = parseInt(section.getAttribute('data-recently-viewed-limit') || '4', 10);
      var selectedHandles = handles.slice(0, Math.max(1, limit));
      var grid = section.querySelector('[data-recently-viewed-grid]');
      var empty = section.querySelector('[data-recently-viewed-empty]');
      if (!grid) return;

      if (!selectedHandles.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }

      Promise.all(selectedHandles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .catch(function () { return null; });
      })).then(function (products) {
        var validProducts = products.filter(Boolean);
        if (!validProducts.length) {
          grid.innerHTML = '';
          if (empty) empty.hidden = false;
          return;
        }

        grid.innerHTML = validProducts.map(createCardHtml).join('');
        if (empty) empty.hidden = true;
        initProductCardVariantSelectors(grid);
        refreshWishlistButtons();
        refreshCompareButtons();
        syncSelectedCardVisualState(grid);
      });
    });
  }

  function renderWishlistSections() {
    var sections = document.querySelectorAll('[data-wishlist-section]');
    if (!sections.length) return;

    var handles = getWishlist();

    sections.forEach(function (section) {
      var limit = parseInt(section.getAttribute('data-wishlist-limit') || '12', 10);
      var selectedHandles = handles.slice(0, Math.max(1, limit));
      var grid = section.querySelector('[data-wishlist-grid]');
      var empty = section.querySelector('[data-wishlist-empty]');
      if (!grid) return;

      if (!selectedHandles.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        updateWishlistSelectionActions(section);
        return;
      }

      Promise.all(selectedHandles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (response) {
            if (!response.ok) return null;
            return response.json();
          })
          .catch(function () { return null; });
      })).then(function (products) {
        var validProducts = products.filter(Boolean);
        if (!validProducts.length) {
          grid.innerHTML = '';
          if (empty) empty.hidden = false;
          return;
        }

        grid.innerHTML = validProducts.map(createCardHtml).join('');
        if (empty) empty.hidden = true;
        initProductCardVariantSelectors(grid);
        refreshWishlistButtons();
        refreshCompareButtons();
        syncSelectedCardVisualState(grid);
        updateWishlistSelectionActions(section);
      });
    });
  }

  function updateWishlistSelectionActions(scope) {
    var sections = [];
    if (scope && scope.matches && scope.matches('[data-wishlist-section]')) {
      sections = [scope];
    } else {
      sections = Array.prototype.slice.call(document.querySelectorAll('[data-wishlist-section]'));
    }

    sections.forEach(function (section) {
      var selectedCount = section.querySelectorAll('[data-card-select]:checked').length;
      var showActions = selectedCount > 0;
      section.querySelectorAll('[data-wishlist-remove-selected], [data-wishlist-clear-selected]').forEach(function (button) {
        button.hidden = !showActions;
      });
    });
  }

  var quickViewModal = document.querySelector('[data-quickview-modal]');
  var quickViewImage = quickViewModal ? quickViewModal.querySelector('[data-quickview-image]') : null;
  var quickViewVendor = quickViewModal ? quickViewModal.querySelector('[data-quickview-vendor]') : null;
  var quickViewTitle = quickViewModal ? quickViewModal.querySelector('[data-quickview-title]') : null;
  var quickViewPrice = quickViewModal ? quickViewModal.querySelector('[data-quickview-price]') : null;
  var quickViewDescription = quickViewModal ? quickViewModal.querySelector('[data-quickview-description]') : null;
  var quickViewSpecs = quickViewModal ? quickViewModal.querySelector('[data-quickview-specs]') : null;
  var quickViewAdd = quickViewModal ? quickViewModal.querySelector('[data-quickview-add]') : null;
  var quickViewLink = quickViewModal ? quickViewModal.querySelector('[data-quickview-link]') : null;
  var promoPopup = document.querySelector('[data-promo-popup]');
  var quoteModal = document.querySelector('[data-quote-modal]');
  var cartUngatingPopup = document.querySelector('[data-cart-ungating-popup]');
  var promoPopupTimer = null;
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartDrawerPanel = cartDrawer ? cartDrawer.querySelector('.sp-cart-drawer__panel') : null;
  var cartDrawerItems = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-items]') : null;
  var cartDrawerSubtotal = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-subtotal]') : null;
  var compareDock = document.querySelector('[data-compare-dock]');
  var compareDockCount = compareDock ? compareDock.querySelector('[data-compare-count]') : null;
  var compareDockList = compareDock ? compareDock.querySelector('[data-compare-dock-list]') : null;
  var compareOverlay = document.querySelector('[data-compare-overlay]');
  var compareGrid = compareOverlay ? compareOverlay.querySelector('[data-compare-grid]') : null;
  var compareProductCache = {};
  var cartDrawerAutoCloseTimer = null;
  var CART_DRAWER_AUTO_CLOSE_MS = 0;
  var CART_DRAWER_EDGE_THRESHOLD_PX = 8;
  var lastRightEdgeOpenAt = 0;
  var cartDrawerRect = null;
  var pendingCursorEvent = null;
  var cursorRaf = null;
  var cartChangeInFlight = false;
  var quoteCaptchaPending = false;
  var QUOTE_ADDITIONAL_DETAILS_LABEL = 'Additional details:';

  var currentQuickProduct = null;

  function isCartDrawerEnabled() {
    return window.innerWidth > 991;
  }

  function measureCartDrawerPanel() {
    if (!cartDrawerPanel) {
      cartDrawerRect = null;
      return;
    }
    cartDrawerRect = cartDrawerPanel.getBoundingClientRect();
  }

  function syncBodyScrollLock() {
    var quickOpen = quickViewModal && !quickViewModal.hidden && quickViewModal.classList.contains('is-open');
    var promoOpen = promoPopup && !promoPopup.hidden;
    var quoteOpen = quoteModal && !quoteModal.hidden;
    var cartUngatingOpen = cartUngatingPopup && !cartUngatingPopup.hidden;
    var cartOpen = cartDrawer && !cartDrawer.hidden && cartDrawer.classList.contains('is-open');
    var compareOpen = compareOverlay && !compareOverlay.hidden && compareOverlay.classList.contains('is-open');
    document.body.classList.toggle('sp-no-scroll', Boolean(quickOpen || promoOpen || quoteOpen || cartUngatingOpen || cartOpen || compareOpen));
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      });
  }

  function clearCartDrawerAutoClose() {
    if (cartDrawerAutoCloseTimer) {
      window.clearTimeout(cartDrawerAutoCloseTimer);
      cartDrawerAutoCloseTimer = null;
    }
  }

  function scheduleCartDrawerAutoClose() {
    if (!isCartDrawerEnabled()) return;
    if (!cartDrawer || cartDrawer.hidden || !cartDrawer.classList.contains('is-open')) return;
    clearCartDrawerAutoClose();
    cartDrawerAutoCloseTimer = window.setTimeout(function () {
      closeCartDrawer();
    }, CART_DRAWER_AUTO_CLOSE_MS);
  }

  function openCartDrawer() {
    if (!isCartDrawerEnabled()) return;
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    cartDrawer.classList.add('is-open');
    window.requestAnimationFrame(measureCartDrawerPanel);
    syncBodyScrollLock();
    fetchCart().then(renderCartDrawer).catch(function () {});
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.hidden = true;
    cartDrawerRect = null;
    clearCartDrawerAutoClose();
    syncBodyScrollLock();
  }

  function handleRightEdgeCursorTrigger(event) {
    if (!isCartDrawerEnabled()) return;
    if (!cartDrawer || !event) return;
    if (cartDrawer.classList.contains('is-open')) {
      if (!cartDrawerPanel) return;
      if (!cartDrawerRect) measureCartDrawerPanel();
      var rect = cartDrawerRect;
      if (!rect) return;
      var clientXOpen = Number(event.clientX || 0);
      var clientYOpen = Number(event.clientY || 0);
      var isInsideDrawer = clientXOpen >= rect.left && clientXOpen <= rect.right && clientYOpen >= rect.top && clientYOpen <= rect.bottom;
      if (!isInsideDrawer) {
        closeCartDrawer();
      }
      return;
    }

    var clientX = Number(event.clientX || 0);
    var atRightEdge = (window.innerWidth - clientX) <= CART_DRAWER_EDGE_THRESHOLD_PX;
    if (!atRightEdge) return;

    var now = Date.now();
    if ((now - lastRightEdgeOpenAt) < 1000) return;
    lastRightEdgeOpenAt = now;
    openCartDrawer();
  }

  function scheduleRightEdgeCursorTrigger(event) {
    pendingCursorEvent = event;
    if (cursorRaf) return;
    cursorRaf = window.requestAnimationFrame(function () {
      var next = pendingCursorEvent;
      pendingCursorEvent = null;
      cursorRaf = null;
      handleRightEdgeCursorTrigger(next);
    });
  }

  function addToCartAjax(variantId, quantity) {
    var payload = new URLSearchParams();
    payload.set('id', String(variantId));
    payload.set('quantity', String(Math.max(1, parseInt(quantity || '1', 10) || 1)));

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: payload.toString()
    }).then(function (response) {
      if (!response.ok) throw new Error('Add failed');
      return fetchCart();
    }).then(function (cart) {
      renderCartDrawer(cart, {
        root: document,
        cartDrawerItems: cartDrawerItems,
        cartDrawerSubtotal: cartDrawerSubtotal
      });
      showToast('Added to cart');
      return cart;
    });
  }

  function changeCartLine(line, quantity) {
    if (cartChangeInFlight) return Promise.resolve(null);
    cartChangeInFlight = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: Number(line || 0),
        quantity: Number(quantity || 0)
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Change failed');
      return response.json();
    }).then(function (cart) {
      renderCartDrawer(cart, {
        root: document,
        cartDrawerItems: cartDrawerItems,
        cartDrawerSubtotal: cartDrawerSubtotal
      });
      return cart;
    }).finally(function () {
      cartChangeInFlight = false;
    });
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (compareProductCache[handle]) return Promise.resolve(compareProductCache[handle]);

    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (product) {
        if (product) compareProductCache[handle] = product;
        return product;
      })
      .catch(function () { return null; });
  }

  function renderCompareOverlay() {
    if (!compareGrid) return;
    var handles = getCompareHandles();
    if (!handles.length) {
      compareGrid.innerHTML = '<p class="sp-compare-overlay__empty">Add products to compare from collection cards.</p>';
      return;
    }

    var products = handles.map(function (handle) { return compareProductCache[handle]; }).filter(Boolean);
    if (!products.length) {
      compareGrid.innerHTML = '<p class="sp-compare-overlay__empty">Loading products...</p>';
      return;
    }

    var headerCells = products.map(function (product) {
      var image = product.featured_image || ((product.images && product.images[0]) ? product.images[0] : '');
      return ''
        + '<div class="sp-compare-cell sp-compare-cell--product">'
        + '  <button type="button" class="sp-compare-matrix__remove" data-compare-remove="' + escapeHtml(product.handle) + '" aria-label="Remove ' + escapeHtml(product.title) + '">×</button>'
        + '  <a href="/products/' + escapeHtml(product.handle) + '" class="sp-compare-matrix__media">'
        +      (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '">' : '<div class="sp-compare-matrix__placeholder"></div>')
        + '  </a>'
        + '  <h3><a href="/products/' + escapeHtml(product.handle) + '">' + escapeHtml(product.title) + '</a></h3>'
        + '  <button type="button" class="sp-card__icon-btn sp-compare-matrix__wishlist" data-wishlist-toggle data-product-handle="' + escapeHtml(product.handle) + '" aria-pressed="false" aria-label="Save ' + escapeHtml(product.title) + ' to wishlist">♡</button>'
        + '</div>';
    }).join('');

    function buildRow(label, resolve) {
      var cells = products.map(function (product) {
        var variant = (product.variants || []).find(function (v) { return v.available; }) || (product.variants || [])[0];
        return '<div class="sp-compare-cell">' + resolve(product, variant) + '</div>';
      }).join('');
      return ''
        + '<div class="sp-compare-row">'
        + '  <div class="sp-compare-cell sp-compare-cell--label">' + label + '</div>'
        +    cells
        + '</div>';
    }

    compareGrid.innerHTML = ''
      + '<div class="sp-compare-matrix" style="--sp-compare-cols:' + String(products.length) + ';">'
      + '  <div class="sp-compare-row sp-compare-row--head">'
      + '    <div class="sp-compare-cell sp-compare-cell--label">Product</div>'
      +      headerCells
      + '  </div>'
      +    buildRow('Price', function (product) {
             var compare = Number(product.compare_at_price || 0);
             var price = Number(product.price || 0);
             return '<p class="sp-compare-matrix__price">' + formatMoney(price) + (compare > price ? ' <span>' + formatMoney(compare) + '</span>' : '') + '</p>';
           })
      +    buildRow('Vendor', function (product) {
             return escapeHtml(product.vendor || 'N/A');
           })
      +    buildRow('Type', function (product) {
             return escapeHtml(product.type || 'N/A');
           })
      +    buildRow('Details', function (product) {
             var detailsText = stripHtml(product.description || '');
             if (!detailsText) return 'N/A';
             return escapeHtml(detailsText.slice(0, 240) + (detailsText.length > 240 ? '...' : ''));
           })
      +    buildRow('Action', function (product, variant) {
             if (!variant) return 'N/A';
             if (!variant.available) return '<button type="button" class="sp-btn sp-btn--muted sp-compare-matrix__add" disabled>Sold out</button>';
             return ''
               + '<div class="sp-compare-matrix__actions">'
               + '  <button type="button" class="sp-btn sp-btn--primary sp-compare-matrix__add" data-compare-add data-variant-id="' + String(variant.id) + '">Add to cart</button>'
               + '  <button type="button" class="sp-btn sp-btn--amber sp-compare-matrix__buy" data-compare-buy-now data-variant-id="' + String(variant.id) + '">Buy now</button>'
               + '</div>';
           })
      + '</div>';
  }

  function renderCompareDock() {
    if (!compareDock) return;
    var handles = getCompareHandles();
    var count = handles.length;
    compareDock.hidden = count === 0;
    if (compareDockCount) compareDockCount.textContent = String(count);

    if (compareDockList) {
      compareDockList.innerHTML = handles.map(function (handle) {
        var product = compareProductCache[handle];
        var label = product ? product.title : handle.replace(/-/g, ' ');
        return '<div class="sp-compare-dock__item"><span>' + escapeHtml(label) + '</span><button type="button" data-compare-remove="' + escapeHtml(handle) + '" aria-label="Remove ' + escapeHtml(label) + '">×</button></div>';
      }).join('');
    }
  }

  function renderCompareUI() {
    var handles = getCompareHandles();
    refreshCompareButtons();
    renderCompareDock();
    renderCompareOverlay();
    if (!handles.length && compareOverlay) {
      compareOverlay.hidden = true;
      compareOverlay.classList.remove('is-open');
      syncBodyScrollLock();
      return;
    }

    Promise.all(handles.map(fetchProductByHandle)).then(function () {
      renderCompareDock();
      renderCompareOverlay();
    });
  }

  function toggleCompareHandle(handle) {
    if (!handle) return;
    var handles = getCompareHandles();
    var idx = handles.indexOf(handle);
    if (idx === -1) {
      handles.unshift(handle);
      handles = handles.slice(0, 4);
      showToast('Added to comparison');
    } else {
      handles.splice(idx, 1);
      showToast('Removed from comparison');
    }
    setCompareHandles(handles);
    renderCompareUI();
  }

  function addHandlesToCompare(handles) {
    if (!handles || !handles.length) return;
    var current = getCompareHandles();

    handles.forEach(function (handle) {
      if (!handle) return;
      var idx = current.indexOf(handle);
      if (idx !== -1) current.splice(idx, 1);
      current.unshift(handle);
    });

    setCompareHandles(current.slice(0, 4));
    renderCompareUI();
    showToast('Added selected items to comparison');
  }

  function addHandlesToCart(handles) {
    if (!handles || !handles.length) return Promise.resolve(false);

    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .catch(function () { return null; });
    })).then(function (products) {
      var items = products.map(function (product) {
        if (!product || !product.variants || !product.variants.length) return null;
        var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        if (!variant || !variant.id) return null;
        return { id: Number(variant.id), quantity: 1 };
      }).filter(Boolean);

      if (!items.length) {
        showToast('No available variants in selection');
        return false;
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Bulk add failed');
          return response.json();
        })
        .then(function () {
          showToast('Added selected items to cart');
          return fetchCart()
            .then(function (cart) {
              renderCartDrawer(cart, {
                root: document,
                cartDrawerItems: cartDrawerItems,
                cartDrawerSubtotal: cartDrawerSubtotal
              });
              openCartDrawer();
              return true;
            })
            .catch(function () {
              openCartDrawer();
              return true;
            });
        })
        .catch(function () {
          showToast('Unable to add selected items');
          return false;
        });
    });
  }

  function initCollectionBulkActions() {
    document.querySelectorAll('[data-collection-bulk]').forEach(function (bulkRoot) {
      if (bulkRoot.getAttribute('data-bulk-init') === 'true') return;
      bulkRoot.setAttribute('data-bulk-init', 'true');

      var sectionRoot = bulkRoot.closest('.sp-collection-main') || document;
      var grid = sectionRoot.querySelector('[data-collection-products]');
      if (window.innerWidth <= 991) {
        bulkRoot.hidden = true;
        if (grid) {
          grid.querySelectorAll('[data-card-select]').forEach(function (input) {
            input.checked = false;
            input.disabled = true;
            updateSelectedCardVisualState(input);
          });
        }
        return;
      }
      var countNode = bulkRoot.querySelector('[data-bulk-selected-count]');
      var addCartButton = bulkRoot.querySelector('[data-bulk-add-cart]');
      var wishlistButton = bulkRoot.querySelector('[data-bulk-wishlist]');
      var compareButton = bulkRoot.querySelector('[data-bulk-compare]');
      var clearButton = bulkRoot.querySelector('[data-bulk-clear]');

      function selectedHandles() {
        if (!grid) return [];
        return Array.prototype.slice.call(grid.querySelectorAll('[data-card-select]:checked'))
          .map(function (input) { return String(input.getAttribute('data-product-handle') || ''); })
          .filter(Boolean);
      }

      function clearSelection() {
        if (!grid) return;
        grid.querySelectorAll('[data-card-select]:checked').forEach(function (input) {
          input.checked = false;
        });
      }

      function updateState() {
        var handles = selectedHandles();
        var count = handles.length;
        if (countNode) countNode.textContent = String(count);
        if (addCartButton) addCartButton.disabled = count === 0;
        if (wishlistButton) wishlistButton.disabled = count === 0;
        if (compareButton) compareButton.disabled = count === 0;
        if (clearButton) clearButton.disabled = count === 0;
        if (grid) {
          grid.querySelectorAll('[data-product-card]').forEach(function (card) {
            var checkbox = card.querySelector('[data-card-select]');
            card.classList.toggle('is-selected', Boolean(checkbox && checkbox.checked));
          });
        }
      }

      if (grid) {
        grid.addEventListener('change', function (event) {
          if (event.target && event.target.matches('[data-card-select]')) updateState();
        });
      }

      if (wishlistButton) {
        wishlistButton.addEventListener('click', function () {
          var handles = selectedHandles();
          if (!handles.length) return;
          addHandlesToWishlist(handles);
          clearSelection();
          updateState();
        });
      }

      if (addCartButton) {
        addCartButton.addEventListener('click', function () {
          var handles = selectedHandles();
          if (!handles.length) return;
          if (addCartButton.disabled) return;
          addCartButton.disabled = true;
          var original = addCartButton.textContent;
          addCartButton.textContent = 'Adding...';
          addHandlesToCart(handles)
            .then(function () {
              updateState();
            })
            .finally(function () {
              addCartButton.disabled = false;
              addCartButton.textContent = original || 'Add selected to cart';
            });
        });
      }

      if (compareButton) {
        compareButton.addEventListener('click', function () {
          var handles = selectedHandles();
          if (!handles.length) return;
          addHandlesToCompare(handles);
          openCompareOverlay();
          clearSelection();
          updateState();
        });
      }

      if (clearButton) {
        clearButton.addEventListener('click', function () {
          clearSelection();
          updateState();
        });
      }

      updateState();
    });
  }

  function removeCompareHandle(handle) {
    if (!handle) return;
    var handles = getCompareHandles().filter(function (item) {
      return item !== handle;
    });
    setCompareHandles(handles);
    renderCompareUI();
    showToast('Removed from comparison');
  }

  function openCompareOverlay() {
    if (!compareOverlay) return;
    compareOverlay.hidden = false;
    compareOverlay.classList.add('is-open');
    syncBodyScrollLock();
    renderCompareOverlay();
  }

  function closeCompareOverlay() {
    if (!compareOverlay) return;
    compareOverlay.classList.remove('is-open');
    compareOverlay.hidden = true;
    syncBodyScrollLock();
  }

  function closeQuickView() {
    if (!quickViewModal) return;
    quickViewModal.classList.remove('is-open');
    quickViewModal.hidden = true;
    if (quickViewSpecs) {
      quickViewSpecs.hidden = true;
      quickViewSpecs.innerHTML = '';
    }
    syncBodyScrollLock();
    currentQuickProduct = null;
  }

  function openPromoPopup() {
    if (!promoPopup || !promoPopup.hidden) return;
    promoPopup.hidden = false;
    syncBodyScrollLock();
  }

  function closePromoPopup() {
    if (!promoPopup) return;
    promoPopup.hidden = true;
    if (promoPopupTimer) {
      window.clearTimeout(promoPopupTimer);
      promoPopupTimer = null;
    }
    syncBodyScrollLock();
  }

  function openQuoteModal() {
    if (!quoteModal) return;
    quoteModal.hidden = false;
    var captchaHost = quoteModal.querySelector('[data-quote-captcha]');
    if (captchaHost) {
      captchaHost.hidden = true;
      captchaHost.innerHTML = '';
    }
    quoteCaptchaPending = false;

    fetchCart()
      .then(function (cart) {
        syncQuoteFormFields(quoteModal, cart, QUOTE_ADDITIONAL_DETAILS_LABEL);
      })
      .catch(function () {});
    syncBodyScrollLock();
  }

  function closeQuoteModal() {
    if (!quoteModal) return;
    quoteModal.hidden = true;
    syncBodyScrollLock();
  }

  function openCartUngatingPopup() {
    if (!cartUngatingPopup || !cartUngatingPopup.hidden) return;
    cartUngatingPopup.hidden = false;
    syncBodyScrollLock();
  }

  function closeCartUngatingPopup() {
    if (!cartUngatingPopup) return;
    cartUngatingPopup.hidden = true;
    syncBodyScrollLock();
  }

  function initCartUngatingPopup() {
    if (!cartUngatingPopup) return;
    if (!/^\/cart(?:\/|$)/.test(currentPath)) return;
    openCartUngatingPopup();
  }

  function parseQuoteChallenge(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    return {
      container: doc.querySelector('.shopify-challenge__container'),
      form: doc.querySelector('form[action*="challenge"]'),
      iframe: doc.querySelector('iframe[src*="challenge"]')
    };
  }

  function renderQuoteChallenge(captchaHost, html, finalUrl) {
    if (!captchaHost) return false;
    var parsed = parseQuoteChallenge(html);
    if (parsed.container) {
      captchaHost.innerHTML = parsed.container.outerHTML;
      return true;
    }
    if (parsed.form) {
      captchaHost.innerHTML = parsed.form.outerHTML;
      return true;
    }
    if (parsed.iframe) {
      captchaHost.innerHTML = parsed.iframe.outerHTML;
      return true;
    }
    if (finalUrl && finalUrl.indexOf('/challenge') !== -1) {
      captchaHost.innerHTML = '<p>Please complete verification to continue.</p><a class="sp-btn sp-btn--muted" href="' + escapeHtml(finalUrl) + '" target="_blank" rel="noopener">Open verification</a>';
      return true;
    }
    return false;
  }

  function bindQuoteChallengeHandlers(captchaHost) {
    if (!captchaHost) return;
    captchaHost.querySelectorAll('form[action*="challenge"]').forEach(function (challengeForm) {
      if (challengeForm.getAttribute('data-quote-challenge-init') === 'true') return;
      challengeForm.setAttribute('data-quote-challenge-init', 'true');
      challengeForm.addEventListener('submit', function (event) {
        event.preventDefault();
        fetch(challengeForm.action, {
          method: (challengeForm.method || 'POST').toUpperCase(),
          credentials: 'same-origin',
          body: new FormData(challengeForm),
          headers: { Accept: 'text/html' }
        })
          .then(function (response) {
            return response.text().then(function (html) {
              return { html: html, url: response.url || '' };
            });
          })
          .then(function (payload) {
            var challengeStillNeeded = renderQuoteChallenge(captchaHost, payload.html || '', payload.url || '');
            captchaHost.hidden = !challengeStillNeeded;
            if (challengeStillNeeded) {
              bindQuoteChallengeHandlers(captchaHost);
              return;
            }
            quoteCaptchaPending = false;
            showToast('Quote request sent');
            closeQuoteModal();
          })
          .catch(function () {
            showToast('Verification failed');
          });
      });
    });
  }

  function handleQuoteFormSubmit(event) {
    var form = event && event.target ? event.target : null;
    if (!form || form.id !== 'sp-quote-form') return false;

    event.preventDefault();
    if (form.getAttribute('data-submitting') === 'true') return true;
    form.setAttribute('data-submitting', 'true');

    var captchaHost = quoteModal ? quoteModal.querySelector('[data-quote-captcha]') : null;
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalSubmitLabel = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
    }

    if (captchaHost) {
      captchaHost.hidden = true;
      captchaHost.innerHTML = '';
    }

    fetchCart()
      .catch(function () { return null; })
      .then(function (cart) {
        syncQuoteFormFields(quoteModal, cart, QUOTE_ADDITIONAL_DETAILS_LABEL);
        return fetch(form.action || '/contact', {
          method: 'POST',
          credentials: 'same-origin',
          body: new FormData(form),
          headers: { Accept: 'text/html' }
        });
      })
      .then(function (response) {
        return response.text().then(function (html) {
          return { html: html, url: response.url || '' };
        });
      })
      .then(function (payload) {
        var html = payload.html || '';
        var finalUrl = payload.url || '';
        if (captchaHost && renderQuoteChallenge(captchaHost, html, finalUrl)) {
          quoteCaptchaPending = true;
          captchaHost.hidden = false;
          bindQuoteChallengeHandlers(captchaHost);
          return;
        }

        if (quoteCaptchaPending) {
          showToast('Quote request sent');
        }
        quoteCaptchaPending = false;
        closeQuoteModal();
      })
      .catch(function () {
        showToast('Unable to send quote request');
      })
      .finally(function () {
        form.removeAttribute('data-submitting');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalSubmitLabel || 'Send quote request';
        }
      });

    return true;
  }

  function initQuoteFormAjax() {
    var quoteForm = document.getElementById('sp-quote-form');
    if (!quoteForm) return;
    if (quoteForm.getAttribute('data-quote-init') === 'true') return;
    quoteForm.setAttribute('data-quote-init', 'true');
    quoteForm.addEventListener('submit', handleQuoteFormSubmit);
    quoteForm.addEventListener('input', function () {
      syncQuoteFormFields(quoteModal, null, QUOTE_ADDITIONAL_DETAILS_LABEL);
    });
  }

  function initCartAutoUpdate() {
    document.querySelectorAll('[data-cart-auto-update]').forEach(function (form) {
      if (form.getAttribute('data-cart-auto-init') === 'true') return;
      form.setAttribute('data-cart-auto-init', 'true');

      var submitTimer = null;

      function scheduleSubmit() {
        if (form.getAttribute('data-cart-auto-submitting') === 'true') return;
        window.clearTimeout(submitTimer);
        submitTimer = window.setTimeout(function () {
          form.setAttribute('data-cart-auto-submitting', 'true');
          form.requestSubmit();
        }, 450);
      }

      form.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
        input.addEventListener('input', scheduleSubmit);
        input.addEventListener('change', scheduleSubmit);
      });
    });
  }

  function initChatOverlay() {
    var root = document.querySelector('[data-chat-widget]');
    if (!root) return;
    if (root.getAttribute('data-chat-init') === 'true') return;
    root.setAttribute('data-chat-init', 'true');

    var toggle = root.querySelector('[data-chat-toggle]');
    var panel = root.querySelector('[data-chat-panel]');
    var closeButton = root.querySelector('[data-chat-close]');
    var form = root.querySelector('#sp-chat-form');

    function open() {
      if (!panel || !toggle) return;
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    function close() {
      if (!panel || !toggle) return;
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (!panel) return;
        if (panel.hidden) open();
        else close();
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    }

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var submitButton = form.querySelector('button[type="submit"]');
        var originalLabel = submitButton ? submitButton.textContent : '';
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Sending...';
        }

        fetch(form.action || '/contact', {
          method: 'POST',
          credentials: 'same-origin',
          body: new FormData(form),
          headers: { Accept: 'text/html' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Contact send failed');
            showToast('Message sent');
            form.reset();
            close();
          })
          .catch(function () {
            showToast('Unable to send message');
          })
          .finally(function () {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalLabel || 'Send';
            }
          });
      });
    }
  }

  function updateQuickViewProduct() {
    if (!currentQuickProduct) return;

    var variant = (currentQuickProduct.variants || []).find(function (v) { return v.available; }) || (currentQuickProduct.variants || [])[0];
    if (!variant) return;

    quickViewPrice.textContent = formatMoney(variant.price);

    var variantImage = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : '';
    var image = variantImage || currentQuickProduct.featured_image || ((currentQuickProduct.images && currentQuickProduct.images[0]) ? currentQuickProduct.images[0] : '');
    if (quickViewImage && image) {
      quickViewImage.src = image;
      quickViewImage.alt = currentQuickProduct.title || '';
    }

    if (quickViewAdd) {
      quickViewAdd.disabled = !variant.available;
      quickViewAdd.textContent = variant.available ? 'Add to cart' : 'Sold out';
      quickViewAdd.setAttribute('data-variant-id', String(variant.id));
    }
  }

  function openQuickView(handle) {
    if (!quickViewModal || !handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product');
        return response.json();
      })
      .then(function (product) {
        currentQuickProduct = product;

        if (quickViewVendor) quickViewVendor.textContent = product.vendor || '';
        if (quickViewTitle) quickViewTitle.textContent = product.title || '';

        var image = product.featured_image || ((product.images && product.images[0]) ? product.images[0] : '');
        if (quickViewImage && image) {
          quickViewImage.src = image;
          quickViewImage.alt = product.title || '';
        }

        if (quickViewDescription) {
          var plain = stripHtml(product.description || '');
          quickViewDescription.textContent = plain.slice(0, 260) + (plain.length > 260 ? '...' : '');
        }
        var hasQuickViewSpecs = renderQuickViewSpecifications(product.description || '');
        if (quickViewDescription) {
          quickViewDescription.hidden = Boolean(hasQuickViewSpecs);
        }

        if (quickViewLink) {
          quickViewLink.href = '/products/' + product.handle;
        }

        updateQuickViewProduct();

        quickViewModal.hidden = false;
        quickViewModal.classList.add('is-open');
        syncBodyScrollLock();
      })
      .catch(function () {
        window.location.href = '/products/' + handle;
      });
  }

  if (quickViewAdd) {
    quickViewAdd.addEventListener('click', function () {
      var variantId = quickViewAdd.getAttribute('data-variant-id');
      if (!variantId) return;

      quickViewAdd.disabled = true;
      var originalLabel = quickViewAdd.textContent;
      quickViewAdd.textContent = 'Adding...';
      addToCartAjax(variantId, 1)
        .then(function () {
          quickViewAdd.textContent = 'Added';
          closeQuickView();
          openCartDrawer();
        })
        .catch(function () {
          quickViewAdd.textContent = originalLabel;
        })
        .finally(function () {
          window.setTimeout(function () {
            quickViewAdd.disabled = false;
            quickViewAdd.textContent = originalLabel;
          }, 900);
        });
    });
  }

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  if (cartDrawerPanel) {
    cartDrawerPanel.addEventListener('mouseenter', function () {
      clearCartDrawerAutoClose();
    });
    cartDrawerPanel.addEventListener('mouseleave', function () {});
    cartDrawerPanel.addEventListener('focusin', function () {
      clearCartDrawerAutoClose();
    });
    cartDrawerPanel.addEventListener('focusout', function () {});
  }

  window.addEventListener('mousemove', scheduleRightEdgeCursorTrigger, { passive: true });
  window.addEventListener('resize', function () {
    if (cartDrawer && cartDrawer.classList.contains('is-open')) {
      window.requestAnimationFrame(measureCartDrawerPanel);
    }
  }, { passive: true });
  document.addEventListener('mouseout', function (event) {
    if (!isCartDrawerEnabled()) return;
    if (!cartDrawer || cartDrawer.hidden || !cartDrawer.classList.contains('is-open')) return;
    if (quoteModal && !quoteModal.hidden) return;
    if (event.relatedTarget || event.toElement) return;
    closeCartDrawer();
  });

  if (promoPopup) {
    promoPopupTimer = window.setTimeout(openPromoPopup, 5000);
    promoPopup.querySelectorAll('[data-promo-popup-close]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closePromoPopup();
      });
    });
  }

  document.querySelectorAll('[data-copy-code]').forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-copy-value') || '';
      if (!code) return;
      var shouldApplyDiscount = button.getAttribute('data-apply-discount') === 'true';
      var discountRedirect = button.getAttribute('data-discount-redirect') || '/';
      var discountUrl = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(discountRedirect);
      var exitPopup = button.closest('[data-exit-intent-popup]');

      if (exitPopup) {
        exitPopup.hidden = true;
        if (typeof syncBodyScrollLock === 'function') syncBodyScrollLock();
      }

      function setCopiedLabel() {
        button.classList.add('is-copied');
        showToast('Copied code');
        window.setTimeout(function () {
          button.classList.remove('is-copied');
        }, 1800);
      }

      function applyDiscountIfNeeded() {
        if (!shouldApplyDiscount) return;
        window.setTimeout(function () {
          window.location.href = discountUrl;
        }, 120);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code)
          .then(function () {
            setCopiedLabel();
            applyDiscountIfNeeded();
          })
          .catch(function () {
            applyDiscountIfNeeded();
          });
        return;
      }

      var temp = document.createElement('textarea');
      temp.value = code;
      temp.setAttribute('readonly', '');
      temp.style.position = 'absolute';
      temp.style.left = '-9999px';
      document.body.appendChild(temp);
      temp.select();
      try {
        document.execCommand('copy');
        setCopiedLabel();
      } catch (e) {}
      document.body.removeChild(temp);
      applyDiscountIfNeeded();
    });
  });

  document.querySelectorAll('[data-newsletter-success]').forEach(function (notice) {
    window.setTimeout(function () {
      notice.style.transition = 'opacity 0.3s ease';
      notice.style.opacity = '0';
      window.setTimeout(function () {
        if (notice.parentNode) notice.parentNode.removeChild(notice);
      }, 320);
    }, 3500);
  });

  document.addEventListener('click', function (event) {
    var removeWishlistSelectedButton = event.target.closest('[data-wishlist-remove-selected]');
    if (removeWishlistSelectedButton) {
      event.preventDefault();
      var removeWishlistSection = removeWishlistSelectedButton.closest('[data-wishlist-section]');
      if (removeWishlistSection) {
        var removeHandles = Array.prototype.slice.call(removeWishlistSection.querySelectorAll('[data-card-select]:checked'))
          .map(function (input) { return String(input.getAttribute('data-product-handle') || ''); })
          .filter(Boolean);
        if (removeHandles.length) {
          removeHandlesFromWishlist(removeHandles);
        }
      }
      return;
    }

    var clearWishlistSelectedButton = event.target.closest('[data-wishlist-clear-selected]');
    if (clearWishlistSelectedButton) {
      event.preventDefault();
      var wishlistSection = clearWishlistSelectedButton.closest('[data-wishlist-section]');
      if (wishlistSection) {
        wishlistSection.querySelectorAll('[data-card-select]:checked').forEach(function (input) {
          input.checked = false;
          updateSelectedCardVisualState(input);
        });
        updateWishlistSelectionActions(wishlistSection);
      }
      return;
    }

    var copySkuButton = event.target.closest('[data-copy-sku]');
    if (copySkuButton) {
      event.preventDefault();
      var productRoot = copySkuButton.closest('.sp-product');
      var skuNode = productRoot ? productRoot.querySelector('[data-product-sku]') : null;
      var sku = skuNode ? (skuNode.textContent || '').trim() : '';
      if (!sku) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(sku).then(function () {
          showToast('Copied SKU');
        }).catch(function () {});
      } else {
        var tempSku = document.createElement('textarea');
        tempSku.value = sku;
        tempSku.setAttribute('readonly', '');
        tempSku.style.position = 'absolute';
        tempSku.style.left = '-9999px';
        document.body.appendChild(tempSku);
        tempSku.select();
        try {
          document.execCommand('copy');
          showToast('Copied SKU');
        } catch (e) {}
        document.body.removeChild(tempSku);
      }
      return;
    }

    var quoteOpen = event.target.closest('[data-quote-open]');
    if (quoteOpen) {
      event.preventDefault();
      closeCartDrawer();
      openQuoteModal();
      return;
    }

    if (event.target.closest('[data-quote-close]')) {
      event.preventDefault();
      closeQuoteModal();
      return;
    }

    if (event.target.closest('[data-cart-ungating-close]')) {
      event.preventDefault();
      closeCartUngatingPopup();
      return;
    }

    var wishlistButton = event.target.closest('[data-wishlist-toggle]');
    if (wishlistButton) {
      event.preventDefault();
      toggleWishlist(wishlistButton);
      return;
    }

    var compareButton = event.target.closest('[data-compare-toggle]');
    if (compareButton) {
      event.preventDefault();
      toggleCompareHandle(compareButton.getAttribute('data-product-handle'));
      return;
    }

    var compareOpenButton = event.target.closest('[data-compare-open]');
    if (compareOpenButton) {
      event.preventDefault();
      openCompareOverlay();
      return;
    }

    var compareRemoveButton = event.target.closest('[data-compare-remove]');
    if (compareRemoveButton) {
      event.preventDefault();
      removeCompareHandle(compareRemoveButton.getAttribute('data-compare-remove'));
      return;
    }

    if (event.target.closest('[data-compare-clear]')) {
      event.preventDefault();
      setCompareHandles([]);
      renderCompareUI();
      return;
    }

    if (event.target.closest('[data-compare-close]')) {
      event.preventDefault();
      closeCompareOverlay();
      return;
    }

    var compareAdd = event.target.closest('[data-compare-add]');
    if (compareAdd) {
      event.preventDefault();
      var compareVariantId = compareAdd.getAttribute('data-variant-id');
      if (!compareVariantId || compareAdd.disabled) return;
      compareAdd.disabled = true;
      addToCartAjax(compareVariantId, 1)
        .then(function () {
          closeCompareOverlay();
          openCartDrawer();
        })
        .finally(function () {
          compareAdd.disabled = false;
        });
      return;
    }

    var compareBuyNow = event.target.closest('[data-compare-buy-now]');
    if (compareBuyNow) {
      event.preventDefault();
      var compareBuyNowVariantId = compareBuyNow.getAttribute('data-variant-id');
      if (!compareBuyNowVariantId || compareBuyNow.disabled) return;
      compareBuyNow.disabled = true;
      addToCartAjax(compareBuyNowVariantId, 1)
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          compareBuyNow.disabled = false;
        });
      return;
    }

    var cartClose = event.target.closest('[data-cart-drawer-close]');
    if (cartClose) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }

    var cartLineChange = event.target.closest('[data-cart-line-change]');
    if (cartLineChange) {
      event.preventDefault();
      changeCartLine(cartLineChange.getAttribute('data-line'), cartLineChange.getAttribute('data-quantity')).catch(function () {});
      return;
    }

    var quickViewButton = event.target.closest('[data-quick-view]');
    if (quickViewButton) {
      event.preventDefault();
      openQuickView(quickViewButton.getAttribute('data-product-handle'));
      return;
    }

    if (event.target.closest('[data-quickview-close]')) {
      event.preventDefault();
      closeQuickView();
      return;
    }

  });

  document.addEventListener('change', function (event) {
    var selectionInput = event.target && event.target.closest ? event.target.closest('[data-card-select]') : null;
    if (!selectionInput) return;
    updateSelectedCardVisualState(selectionInput);
    var wishlistSection = selectionInput.closest ? selectionInput.closest('[data-wishlist-section]') : null;
    if (wishlistSection) updateWishlistSelectionActions(wishlistSection);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.id === 'sp-quote-form') {
      handleQuoteFormSubmit(event);
      return;
    }
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    event.preventDefault();

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = formData.get('quantity') || '1';
    if (!variantId) {
      form.submit();
      return;
    }

    var submitButton = event.submitter;
    var originalLabel = submitButton && submitButton.textContent ? submitButton.textContent : '';
    if (submitButton) {
      submitButton.disabled = true;
      if (originalLabel) submitButton.textContent = 'Adding...';
    }

    addToCartAjax(variantId, quantity)
      .then(function () {
        openCartDrawer();
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submitButton) {
          submitButton.disabled = false;
          if (originalLabel) submitButton.textContent = originalLabel;
        }
      });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && quickViewModal && quickViewModal.classList.contains('is-open')) {
      closeQuickView();
    }
    if (event.key === 'Escape' && promoPopup && !promoPopup.hidden) {
      closePromoPopup();
    }
    if (event.key === 'Escape' && quoteModal && !quoteModal.hidden) {
      closeQuoteModal();
    }
    if (event.key === 'Escape' && cartUngatingPopup && !cartUngatingPopup.hidden) {
      closeCartUngatingPopup();
    }
    if (event.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) {
      closeCartDrawer();
    }
    if (event.key === 'Escape' && compareOverlay && compareOverlay.classList.contains('is-open')) {
      closeCompareOverlay();
    }
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-mega-menu]').forEach(function (menu) {
        menu.removeAttribute('open');
      });
    }
  });

  document.querySelectorAll('[data-qty-decrement]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.sp-qty-row');
      if (!wrap) return;
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var val = parseInt(input.value || '1', 10);
      input.value = String(Math.max(1, val - 1));
    });
  });

  document.querySelectorAll('[data-qty-increment]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.sp-qty-row');
      if (!wrap) return;
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var val = parseInt(input.value || '1', 10);
      input.value = String(val + 1);
    });
  });

  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('[data-tab-target]');
    var panels = tabs.querySelectorAll('[data-tab-panel]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-tab-target');

        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        button.classList.add('is-active');
        var panel = tabs.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-buy-now]').forEach(function (button) {
    button.addEventListener('click', function () {
      var productRoot = button.closest('.sp-product');
      if (!productRoot) return;

      var form = productRoot.querySelector('.sp-product-form');
      if (!form) return;

      var variantInput = form.querySelector('select[name="id"], input[name="id"]');
      if (!variantInput || !variantInput.value) return;

      var qtyInput = form.querySelector('[data-qty-input]');
      var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10) || 1) : 1;
      var originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Processing...';

      var payload = new URLSearchParams();
      payload.set('id', variantInput.value);
      payload.set('quantity', String(quantity));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json'
        },
        body: payload.toString()
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Buy now add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = originalText;
        });
    });
  });

  function parseSpecLine(line) {
    var clean = (line || '').replace(/\s+/g, ' ').trim();
    if (!clean) return null;

    var separatorMatch = clean.match(/^(.+?)\s*(?::| - | – | — )\s*(.+)$/);
    if (!separatorMatch) return null;

    var key = (separatorMatch[1] || '').trim();
    var value = (separatorMatch[2] || '').trim();
    if (!key || !value) return null;

    return { key: key, value: value };
  }

  function isSpecificationsHeading(node) {
    if (!node) return false;

    var text = (node.textContent || '')
      .replace(/\s+/g, ' ')
      .replace(/[.:]/g, '')
      .trim();

    if (!/\b(specs?|specifications?)\b/i.test(text)) return false;
    return /^H[1-6]$/.test(node.tagName) || node.tagName === 'P';
  }

  function isSectionBoundary(node) {
    if (!node) return false;
    if (/^H[1-6]$/.test(node.tagName)) return true;

    if (node.tagName === 'P') {
      var t = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (t && t.length < 60 && /:$/.test(t)) return true;
    }

    return false;
  }

  function collectSpecRows(node, rows) {
    if (!node) return;

    if (node.matches('table')) {
      node.querySelectorAll('tr').forEach(function (tr) {
        var cells = tr.querySelectorAll('th, td');
        if (cells.length >= 2) {
          for (var i = 0; i + 1 < cells.length; i += 2) {
            var key = (cells[i].textContent || '').trim();
            var value = (cells[i + 1].textContent || '').trim();
            if (key && value) rows.push({ key: key, value: value });
          }
        }
      });
      return;
    }

    if (node.matches('ul, ol')) {
      node.querySelectorAll('li').forEach(function (li) {
        var parsed = parseSpecLine(li.textContent);
        if (parsed) rows.push(parsed);
      });
      return;
    }

    var text = (node.textContent || '').trim();
    if (!text) return;

    var parsedAny = false;
    var cleanLines = text
      .split('\n')
      .map(function (line) { return (line || '').replace(/\s+/g, ' ').trim(); })
      .filter(function (line) { return line.length > 0; });

    cleanLines.forEach(function (line) {
      var parsed = parseSpecLine(line);
      if (parsed) {
        parsedAny = true;
        rows.push(parsed);
      }
    });

    // Fallback: support alternating lines like:
    // Battery Type
    // A27
    // Voltage
    // 12 V
    if (!parsedAny && cleanLines.length >= 2) {
      for (var j = 0; j + 1 < cleanLines.length; j += 2) {
        var keyLine = cleanLines[j];
        var valueLine = cleanLines[j + 1];
        if (keyLine && valueLine) rows.push({ key: keyLine, value: valueLine });
      }
    }
  }

  function renderQuickViewSpecifications(descriptionHtml) {
    if (!quickViewSpecs) return;

    var rows = [];
    var doc = new DOMParser().parseFromString(descriptionHtml || '', 'text/html');
    var heading = null;

    doc.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach(function (node) {
      if (!heading && isSpecificationsHeading(node)) heading = node;
    });

    if (heading) {
      var currentNode = heading.nextElementSibling;
      while (currentNode) {
        if (isSectionBoundary(currentNode)) break;
        collectSpecRows(currentNode, rows);
        currentNode = currentNode.nextElementSibling;
      }
    }

    if (!rows.length) {
      quickViewSpecs.hidden = true;
      quickViewSpecs.innerHTML = '';
      return false;
    }

    var bodyHtml = '';
    for (var i = 0; i < rows.length; i += 2) {
      var left = rows[i];
      var right = rows[i + 1];
      bodyHtml += '<tr>';
      bodyHtml += '<th>' + escapeHtml(left.key) + '</th><td>' + escapeHtml(left.value) + '</td>';
      if (right) {
        bodyHtml += '<th>' + escapeHtml(right.key) + '</th><td>' + escapeHtml(right.value) + '</td>';
      }
      bodyHtml += '</tr>';
    }

    quickViewSpecs.innerHTML = '<div class="sp-spec-table-wrap"><table class="sp-spec-table"><tbody>' + bodyHtml + '</tbody></table></div>';
    quickViewSpecs.hidden = false;
    return true;
  }

  function enhanceDescriptionSpecifications() {
    document.querySelectorAll('[data-tab-panel="details"]').forEach(function (panel) {
      if (panel.querySelector('.sp-spec-table')) return;

      var specsHeading = null;
      panel.querySelectorAll('h1, h2, h3, h4, h5, h6, p').forEach(function (node) {
        if (!specsHeading && isSpecificationsHeading(node)) {
          specsHeading = node;
        }
      });
      if (!specsHeading) return;

      var rows = [];
      var consumedNodes = [];
      var currentNode = specsHeading.nextElementSibling;

      while (currentNode) {
        if (isSectionBoundary(currentNode)) break;
        collectSpecRows(currentNode, rows);
        consumedNodes.push(currentNode);
        currentNode = currentNode.nextElementSibling;
      }
      if (!rows.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'sp-spec-table-wrap';

      var table = document.createElement('table');
      table.className = 'sp-spec-table';

      var tbody = document.createElement('tbody');
      for (var i = 0; i < rows.length; i += 2) {
        var row = rows[i];
        var rowTwo = rows[i + 1];
        var tr = document.createElement('tr');
        var th = document.createElement('th');
        var td = document.createElement('td');
        th.textContent = row.key;
        td.textContent = row.value;
        tr.appendChild(th);
        tr.appendChild(td);

        if (rowTwo) {
          var thTwo = document.createElement('th');
          var tdTwo = document.createElement('td');
          thTwo.textContent = rowTwo.key;
          tdTwo.textContent = rowTwo.value;
          tr.appendChild(thTwo);
          tr.appendChild(tdTwo);
        }

        tbody.appendChild(tr);
      }

      table.appendChild(tbody);
      wrap.appendChild(table);
      specsHeading.insertAdjacentElement('afterend', wrap);

      consumedNodes.forEach(function (node) {
        node.remove();
      });
    });
  }

  function runNonCriticalInitializers() {
    initMegaPanelViewportFit();
    initPageTransitions();
    initExitIntentPopup();
    initQuoteFormAjax();
    initCartUngatingPopup();
    initCartAutoUpdate();
    initChatOverlay();
    if (isCollectionRoute) initCollectionBulkActions();
    initMegaMenuThumbHydration();
    initCollectionLinkPrefetch();
    if (getCompareHandles().length > 0) {
      refreshCompareButtons();
      renderCompareDock();
    }
    renderRecentlyViewed();
    renderWishlistSections();
    updateWishlistSelectionActions();
    if (isProductRoute) enhanceDescriptionSpecifications();
    refreshWishlistButtons();
  }

  (function () {
    var scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        scrollTicking = false;
        onScroll();
      });
    }, { passive: true });
  })();
  initAnnouncementRotation();
  initMegaMenu();
  initSearchAutocomplete();
  initBackToTop();
  initProductCardVariantSelectors(document);
  initCollectionLoadMore();
  initCollectionFilterAvailability();
  initSearchFilterAvailability();
  initSearchLoadMore();
  syncSelectedCardVisualState(document);
  recordRecentlyViewed();
  refreshWishlistButtons();
  onScroll();

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(runNonCriticalInitializers, { timeout: 1200 });
  } else {
    window.setTimeout(runNonCriticalInitializers, 240);
  }
})();
